<template>
  <div about>
    <div class="wrapper">
      <h2>
        WH<span>ERE</span>
        <img src="/static/img/about/possible.png" class="possible">
      </h2>
      <div class="hand"></div>
      <section class="intro">
        <div class="copy">
          선택,<br>
          이제부터 나 스스로,<br>
          간편하게!
        </div>
        <div class="box">
          <h4>여성질병 검사를 위한<br>
            셀프 검체 Kit , GYNPAD</h4>
          <p>세상의 모든 여자들이<br>
          나이, 인종, 종교, 거주지, 직업, 결혼유무<br>
          그 모든것과 상관없이<br>
          시간과 장소에 구애 받지 않고<br>
          나 스스로 검체 채취를 할 수 있습니다.<br>
          <br>
          가인패드는 패드 착용만으로 검체를 채취합니다.</p>
        </div>
      </section>
      <section class="why">
        <h3><em>WHY</em>GYNPAD?</h3>
        <p>자궁경부 및 여성질병 검사를 위한<em>셀프 검체 Kit, GYNPAD</em></p>
        <div class="play">
          <img src="/static/img/about/g-bg.png" alt="" class="bg">
          <img src="/static/img/common/fhd.png" alt="">
          <iframe src="https://www.youtube.com/embed/nyAi32t68mY?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
      </section>
      <section class="feature">
        <h3>여성질병 검체 채취 방법,<br>
          <em>이제, 당신이 선택하세요!</em></h3>
        <ol>
          <li>
            <img src="/static/img/about/illust01.png" alt="">
            <div>
              <h4>
                <em><strong>01.</strong>YOUR CHOICE</em>
                당신에게 선택권이 주어지다!</h4>
              <p>가인패드 출시로 인하여<br>
                <em>자궁경부 및 여성 질병검사</em>를 위한<br>
                검체 채취 방법에도 선택권이 생겼습니다.<br>
                간편하게 셀프 채취하는 가인패드를 선택하세요.</p>
            </div>
          </li>
          <li class="tr">
            <img src="/static/img/about/illust02.png" alt="">
            <div>
              <h4>
                <em><strong>02.</strong>CLOSE TO<br>WOMAN</em>
                여성에게<br>친근한 방법을 생각하다!</h4>
              <p>여성에게 친근하고 거부감 없는 팬티라이너 형태로 제작,<br>
                장소와 시간적 제약 없이 검체를 채취할 수 있습니다.</p>
            </div>
          </li>
          <li>
            <img src="/static/img/about/illust03.png" alt="">
            <div>
              <h4>
                <em><strong>03.</strong>MYSELF FOR<br>4 HOURS</em>
                4시간 착용으로<br> 셀프 검체가 가능해지다</h4>
              <p>4시간 착용으로 스스로 검체 채취가 가능하기 때문에<br>
                수시로  여성질병의 검체 채취를 해보실 수 있습니다.<br>
                <span>※ 가인패드의 착용 시간은 낮(활동시간)에 4시간 이상을 권장합니다.<br>
                ※ 필터를 떼어 내시기 전에 분비물이 없는 경우 8시간까지 착용을 권장합니다.</span></p>
            </div>
          </li>
        </ol>
      </section>
      <section class="components">
        <div class="pin">
          <h3><em>GYNPAD</em>구성품</h3>
          <ol class="names">
            <li><i>1</i>가인패드 패키지</li>
            <li><i>2</i>가인패드</li>
            <li><i>3</i>발송용 스티커</li>
            <li><i>4</i>사용설명서</li>
            <li><i>5</i>검체 보존용 시약</li>
            <li><i>6</i>용기 부착용 스티커</li>
          </ol>
        </div>
        <div class="map">
          <div class="points">
            <i>1</i>
            <i>2</i>
            <i>3</i>
            <i>4</i>
            <i>5</i>
            <i>6</i>
            <img src="/static/img/about/components.png" >
          </div>
        </div>
        <a class="btn" @click="cert = true">특허 및 인증</a>

        <h3><em>GYNPAD</em>사용방법</h3>
        <ol class="method">
          <li>
            <i>1</i>
            <img src="/static/img/about/method_01.png" alt="">
            <p>가인패드의 필터가<br>
              질 입구에 위치하도록<br>
              팬티에 잘 부착합니다.</p>
          </li>
          <li>
            <i>2</i>
            <img src="/static/img/about/method_02.png" alt="">
            <p>가인패드의 착용 시간은<br>
              <b>*4시간이상</b>이 좋습니다.</p>
          </li>
          <li>
            <i>3</i>
            <img src="/static/img/about/method_03.png" alt="">
            <p>1회용 장갑을 착용하고<br>
              질 분비물이 묻은 필터의<br>
              붉은 색 부분을 잡고<br>
              떼어냅니다.</p>
          </li>
          <li>
            <i>4</i>
            <img src="/static/img/about/method_04.png" alt="">
            <p>떼어낸 필터를 통에<br>
              넣을 때 질 분비물이 묻은<br>
              부분이 바깥으로 향하게<br>
              말아서 넣습니다.</p>
          </li>
          <li>
            <i>5</i>
            <img src="/static/img/about/method_05.png" alt="">
            <p>동봉된 라벨에 정보를<br>
              기입한 후, 보존 용기 표면에<br>
              가로 방향으로 붙입니다.</p>
          </li>
          <li>
            <i>6</i>
            <img src="/static/img/about/method_06.png" alt="">
            <p>박스뚜껑을 닫고,<br>
              발송용 라벨을 붙여<br>
              박스를 밀봉합니다.</p>
          </li>
        </ol>
        <p class="desc">※ 가인패드의 착용 시간은 낮(활동시간)에 4시간 이상을 권장합니다. <br>※ 개인차에 따라 분비물의 양이 적을 수 있습니다. <span class="hidden-sm-down"><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>필터를 떼어 내시기 전에 분비물이 없는 경우 8시간까지 착용을 권장합니다.</p>
      </section>
    </div>
    <transition name="fade">
      <popup v-if="cert">
        <div class="panel">
          <div class="close" @click="cert = false"></div>
          <h3>특허 및 인증</h3>
          <p>가인패드의 특허 및 인증내용을 확인해보세요</p>
          <img src="/static/img/about/cert_m.png" alt="" class="mobile">
          <img src="/static/img/about/cert_pc.png" alt="" class="pc">
          <a @click="cert = false" class="btn black">확&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;인</a>
        </div>
      </popup>
    </transition>
  </div>
</template>

<style lang="less" scoped>
  @import "../less/gynpad";
  @import "../less/asset";
  [about] { background: #f7f6f5; .rel; overflow:hidden; }

  h2 { .karla; .bold; .fs(5.5em); .rwh(315,190); .m-hc; .rel; letter-spacing: -5px;
    span { color:@c-about; .rel;
      &:after { content:''; .block; .lb-r(0,8); .wf; .rp-r(5); .border-t(@c-about, 0.2rem); }
    }
    .possible { .rw(269); .rt-r(-15,75); }
  }

  .hand { .cover('@{about}/hand.png'); .rwh(300); .fr; .rel; z-index: 1; margin-left: 20px; }

  section.intro { clear: both; padding-right: 15%;
    .copy { .fs(2rem); color: @c-about; .tr; letter-spacing: -1px; .rm-b(25); }
    .box { .tr; .rp-v(32); .rp-r(60); .border(#fff, 5px); border-left:0; .border-box;
      h4 { .fs(1.5rem); .rm-b(18); }
    }
  }

  section.why { .rp-h(30); .rp-b(80); .rel; .rm-t(50);
    h3 { .fsl(4.3rem, 1); .karla; .bold;
      em { .block; .fs(5.3rem); }
    }
    p { .rm-t(5);
      em { .block; .fs(1.5rem);}
    }
    .play { width:80%; .rel; .rm-t(100);
      .bg { .rt(-130px,-178px); width:250px; }
      img { width: 100%; }
      iframe { .lt; .wh(100%); }
    }
  }

  section.feature { .rp-h(30); .rm-t(50);
    h3 { .fs(1.5rem); color: #333; .tc;
      em { .ib; color: @c-about; .fs(2rem);
        &:after { content: ''; .block; .wh(85%, 1px); background: @c-about; .m-hc;}
      }
    }
    ol {
      li { .rm-t(55);
        img { width: 100%; }
        h4 { .fs(2rem); .rm-t(20); letter-spacing: -1px;
          em { .block; .karla; .bold; .fsl(3rem, 1); .rm-b(10); letter-spacing: -2px;
            strong { .block; color: @c-about; letter-spacing: -1px;}
          }
        }
        p { .rm-t(10);
          em { color: @c-about; }
          span { color: @c-pink; .fs(0.8rem); .block; line-height: 1.4;}
        }
      }
    }
  }

  section.components { .rp-h(30);
    h3 { .fs(2.3rem);  .rm-t(50);
      em { .block; .fsl(3.5rem,1); .karla; .bold;}
    }
    ol.names { .ib-list; .rm-t(10); .rw(280);
      li { .rw(140); .fsl(1.25rem,1.6);
        i { .ib; .rwh(20); background:@c-pink; .tc; color:#fff; .fsl(1rem,1.8); .vam; border-radius: 50%; .rm-r(5); }
      }
    }
    .map { .rm-h(-30); .rel; margin-top:40px;
      img { width: 100%; }
      i { .block; .rwh(30); background: @c-pink; color: #fff; .fsl(1.2rem, 2.2); .tc; .vam; border-radius: 50%; .rm-l(-15); .rm-t(-15);
        &:nth-child(1) { .lt(34%,13%); }
        &:nth-child(2) { .lt(13%,43%); }
        &:nth-child(3) { .lt(16%,62%); }
        &:nth-child(4) { .lt(56%,49%); }
        &:nth-child(5) { .lt(78%,32%); }
        &:nth-child(6) { .lt(28%,80%); }
      }
    }
    .btn { .fsl(1.2rem,1); color:#fff; .rp(10); background: #000; .rw(200); .tc; .m-hc; .block; .rm-t(20); }
    ol.method { .ib-list; .rm-t(20);
      li { width: 50%; .rel; .rm-b(30);
        i { .lt; .fs(2rem); }
        img { width: 100%; }
        p { .tc;}
      }
    }
    p.desc { .fs(0.9rem); .rm-b(20); .rel; top:-1rem; .tl; }
  }

  [popup] {
    .panel { .rm(30); .rp(35,25); background:#fff; .border-box; .border(@c-pink, 2px); .rel; .tc;
      .close { .rt-r(18,18); .rwh(18); .contain('@{common}/close_pink.svg'); }
      h3 { .fsl(2.5rem,1); }
      p { .fs(1.1rem); }
      img { max-width:100%; .rm-t(20); .block; .m-hc; }
      .btn { .rm-t(20); .rw(180); }
      .pc { .hide; }
    }
  }

  @media (min-width: @screen-md-min) {
    h2 { width: 465px;
      .possible { .rb(-16px,62px);}
    }
    section.intro { clear:none; .rh(400);
      .box { width:auto; .border-l(#fff, 5px); .rp-l(50); .abs; right: 21rem; }
    }
    section.why {
      .play {
        .bg { .rt(-190px,-284px); width:auto; }
      }
    }
    section.components p.desc { .m-hc; width: 400px; }
  }

  @media (min-width: @screen-lg-min) {
    .wrapper { max-width:1660px; .m-hc; padding-top:130px; padding-bottom: 130px; }
    h2 { .fs(110px); width: 710px; margin-bottom:50px;
      .possible { .rb(9px,20px); width: auto;}
    }
    .hand { width:50%; height: 659px; background-size: 877px 659px; }
    section.intro { height: 600px;
      .copy { .fsl(40px, 50px); letter-spacing: -3px; }
      .box { .border(#fff, 10px); padding:30px 120px 30px 100px; width:auto; right:calc(~"50% - 107px");
        h4 { .fsl(30px,40px); letter-spacing: -2px; }
        p { .fs(18px); letter-spacing: -1px; }
      }
    }
    section.why { width:920px; .m-hc;
      h3 { .fs(90px); .vab; .ib; .rel;
        em { .fs(110px); }
      }
      p { .fs(18px); .vab; .ib;.rel; z-index: 1; margin-left: 60px;
        em { .fs(24px); }
      }
      .play { margin-top:50px;}
    }
    section.feature {
      h3 { .fs(36px);
        em { .fs(48px);
          &:after { .wh(100%, 2px); }
        }
      }
      ol {
        li { margin-top:50px; .clear;
          & > div { .ib;
            h4 { margin-top:0; }
          }
          & > img { float:left; width: 50%; margin-right: 40px; }
          &.tr {
            & > img { float:right; margin-left: 40px; margin-right:0; }
          }
          h4 { .fs(40px); letter-spacing: -2px;
            em { .fs(60px);
              strong {}
            }
          }
          p { .fs(20px); letter-spacing: -1px;
            em {}
            span { .fs(16px); }
          }
        }
      }
    }
    section.components {
      h3 { .fs(48px);
        em { .fs(72px); }
      }
      ol.method { width: 850px; .m-hc;
        li { width: 33.333%;
          p { .tl; margin-left:50px; .fs(20px); }
          i { .lt(5px,213px); .fs(40px); }
        }
      }
      p.desc { .fs(18px); width:600px; top:0; margin-top:20px; }
    }

    [popup] {
      .panel { width: 890px; .m-hc; .border(@c-pink, 4px);
        .close { .wh(66px,108px); .contain('@{common}/close_pink_pc.png'); .rt(-70px,-4px); }
        h3 { .fsl(40px,50px); .medium; }
        p { .fsl(24px,34px); }
        .mobile { .hide; }
        .pc { .block; }
        .btn { .fs(24px); width:300px; }
      }
    }
  }

  @media (min-width: @screen-xl-min) {
    section.feature { width:1240px; .m-hc; }
    section.components { width:1240px; .m-hc; .rel;
      h3 { .rel; z-index: 1;}
      ol.names { .abs; z-index: 1;
        li { .block; }
      }
      .map { margin: -30px 0 0;}
      .btn { .abs; .fs(24px); padding:18px; right:0; margin-top:-30px; }
    }
  }
</style>

<script>
import Popup from '../components/Pop.vue';

export default {
  name: 'About',
  components: { Popup },
  data() {
    return {
      cert: false,
      whIndex: 0,
      whList: ['ERE', 'O', 'AT', 'EN'],
      whDom: null,
      whInterval: -1,
    };
  },
  methods: {
    whEffect() {
      this.whDom.animate({ left: 10, opacity: 0 }, () => {
        this.whIndex += 1;
        if (this.whIndex === 4) this.whIndex = 0;
        this.whDom.text(this.whList[this.whIndex]).animate({ left: 0, opacity: 1 });
      });
    },
  },
  mounted() {
    this.whDom = window.$('h2 span');
    this.whInterval = setInterval(this.whEffect, 2000);
  },
  beforeDestroy() {
    clearInterval(this.whInterval);
  },
};
</script>



// WEBPACK FOOTER //
// src/views/About.vue